// @file Logic that decides when to show comments drawer on mobile
// This was factored out to avoid circular dependencies between stores.
import { isDraftForNewComment } from '@@/bits/surface_comments'
import { useExpandedPostStore } from '@@/pinia/expanded_post'
import { useCommentsStore } from '@@/pinia/surface_comments'
import { useSurfaceContainerSizeStore } from '@@/pinia/surface_container_size'
import type { CommentDraft } from '@@/types/surface_comments'
import type { ComputedRef } from 'vue'
import { computed } from 'vue'

function useSurfaceCommentDrawer(): {
  commentDrawerDraft: ComputedRef<CommentDraft | null>
  xAddCommentDrawer: ComputedRef<boolean>
  xEditCommentDrawer: ComputedRef<boolean>
} {
  const surfaceContainerSizeStore = useSurfaceContainerSizeStore()
  const commentsStore = useCommentsStore()
  const expandedPostStore = useExpandedPostStore()

  const commentDrawerDraft = computed(() => {
    if (!surfaceContainerSizeStore.isPhone) return null
    return commentsStore.latestDraftBeingWritten
  })

  const xAddCommentDrawer = computed(() => {
    if (commentDrawerDraft.value == null) return false
    return isDraftForNewComment(commentDrawerDraft.value) && !expandedPostStore.xExpandedPostPanel
  })

  const xEditCommentDrawer = computed(() => {
    if (commentDrawerDraft.value == null) return false
    return !isDraftForNewComment(commentDrawerDraft.value)
  })

  return { commentDrawerDraft, xAddCommentDrawer, xEditCommentDrawer }
}
export { useSurfaceCommentDrawer }
